import React from 'react';
import { Box, Skeleton, TableRow, TableCell } from '@mui/material';

export function TableLoadingSkeleton({ rows = 5, columns = 6 }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, rIdx) => (
        <TableRow key={rIdx}>
          {Array.from({ length: columns }).map((_, cIdx) => (
            <TableCell key={cIdx}>
              <Skeleton
                variant={cIdx === 0 ? 'rounded' : 'text'}
                height={cIdx === 0 ? 28 : 20}
                width={cIdx === 0 ? 28 : cIdx === 1 ? '70%' : '50%'}
                animation="wave"
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}

export default function LoadingState({ height = 200, rows = 3 }) {
  return (
    <Box sx={{ width: '100%', p: 2 }}>
      {Array.from({ length: rows }).map((_, idx) => (
        <Skeleton
          key={idx}
          variant="rounded"
          height={height / rows - 12}
          sx={{ mb: 1.5, borderRadius: 2 }}
          animation="wave"
        />
      ))}
    </Box>
  );
}
